import React from "react";
import { ClerkContext } from "../providers/clerk-token.tsx";

export function useClerkToken() {
  return React.useContext(ClerkContext);
}
